import { injectable } from "@launchtray/tsyringe-async";
import { ICellModel } from "../../../models/cell/ICellModel";
import { CellModel } from "../../../models/cell/impl/CellModel";
import { ICellModelFactory } from "../ICellModelFactory";
import { FullSquareModelFactory } from "../../squares/impl/FullSquareModelFactory";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { PieceColor } from "../../../enums/PieceColor";
import { HalfSquareModelFactory } from "../../squares/impl/HalfSquareModelFactory";

@injectable()
export class FilledCellModelFactory implements ICellModelFactory{
    private readonly possibleValues = [
        TriangleRotationStatus.BOTTOM_LEFT, 
        TriangleRotationStatus.BOTTOM_RIGHT, 
        TriangleRotationStatus.TOP_LEFT, 
        TriangleRotationStatus.TOP_RIGHT
    ];

    private readonly initialColor: PieceColor;

    public constructor(
        private readonly fullSquareModelFactory: FullSquareModelFactory,
        private readonly halfSquareModelFactory: HalfSquareModelFactory
    ) {
        const colors = [PieceColor.BLUE, PieceColor.GREEN, PieceColor.ORANGE, PieceColor.PURPLE, PieceColor.RED, PieceColor.YELLOW];
        const randomColor = colors.random();
        if (Array.isArray(randomColor)) {
            console.warn("FilledCellModelFactory in constructor generated array of initial colors!");
            return;
        }
        this.initialColor = randomColor;
    }

    public createCell(): ICellModel {
        // const rndFactory = Math.round(Math.random()) == 1 ? this.fullSquareModelFactory : this.halfSquareModelFactory;
        const rndKey = Math.round(Math.random() * (this.possibleValues.length - 1));
        return new CellModel(this.fullSquareModelFactory.createSquare(this.possibleValues[rndKey], this.initialColor));
    }
}